import React from 'react';

interface ArrowRightProps {
  width?: string;
  height?: string;
  className?: string;
  stroke?: string;
}

const ArrowRight = ({
  width = '21',
  height = '20',
  className,
  stroke = '#475467'
}: ArrowRightProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M4.66602 10.0003H16.3327M16.3327 10.0003L10.4993 4.16699M16.3327 10.0003L10.4993 15.8337"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRight;
